import React, {Component} from "react";
import {Modal, Button, Form} from "semantic-ui-react";


export default class RampSetupModal extends Component {
  vistisHeader=()=>{
     const arr=[];
     for(let i=0;i<=15;i++){
         arr.push(( <th className={`cursorPointer}`}  >
             <div>
                 {i}  VISITS
             </div>
         </th>))
     }
     return arr;
    }
    render() {
        return(
            <Modal
                open={this.props.rampSetupModal}
                style = {{ overflow: 'auto' }}
                closeIcon
                onClose={() => this.props.toggleRampSetupModal(this.props.rampSetupModal)}

            >
                <Modal.Header>
                    Ramp ThreshHold
                </Modal.Header>
                <Modal.Content>
                    <table className="table table-striped table-hover my-0">
                        <thead>
                        <tr>
                            <th className={`cursorPointer}`}  >
                                <div>
                                    Practice
                                </div>
                            </th>
                            {this.vistisHeader()}

                        </tr>

                        </thead>
                        <tbody>
                        {this.props.getRampSetupData}

                        </tbody>
                    </table>

                    { this.props.rampSetupFormEdit ?

                        <Form className="formStyle">
                            <Form.Group widths='equal'>
                                <Form.Input
                                    fluid
                                    label='Patient Visit Per Month'
                                    placeholder='number'
                                    name="patientVisits"
                                    value = {this.props.rampSetupForm.patientVisits}
                                    onChange={(e) => this.props.onChangeRampInput(e)}
                                />
                                <Form.Input
                                    fluid
                                    label='Reduced Production Threshold'
                                    placeholder='number'
                                    name="productionThreshold"
                                    value = {this.props.rampSetupForm.productionThreshold}
                                    onChange={(e) => this.props.onChangeRampInput(e)}
                                />
                            </Form.Group>
                        </Form>
                        :
                        <Form className="formStyle">
                            <Form.Group widths='equal'>
                                <Form.Input
                                    fluid
                                    label='Patient Visit Per Month'
                                    placeholder='number'
                                    name="patientVisits"
                                    onChange={(e) => this.props.onChangeRampInput(e)}
                                />
                                <Form.Input
                                    fluid
                                    label='Reduced Production Threshold'
                                    placeholder='number'
                                    name="productionThreshold"
                                    onChange={(e) => this.props.onChangeRampInput(e)}
                                />
                            </Form.Group>
                        </Form>

                    }

                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <Button onClick={this.props.saveRampSetUp} className={"primary"}>
                            {this.props.rampSetupFormEdit ? 'Update': 'Create'}
                        </Button>
                    </div>
                </Modal.Actions>

            </Modal>
        )
    }
}
